module.exports = __webpack_public_path__ + "57d6249d4278675d7d10d9853b951ff6.png";